/** MethodologyBanner — compliance-required disclaimer banner shown above
 *  every chart that surfaces MODEL-derived (i.e. not panel-measured) numbers.
 *  Required under Ghana's Act 843 §35 (inferred personal data must be disclosed). */
import { Link } from "react-router-dom";
import { T } from "@/lib/theme";

const C = T.dark;

const COPY = {
  MODEL: {
    title: "Model-derived estimate",
    body: "These numbers are computed from live stream telemetry and statistical modelling, not panel surveys. Treat them as directional, not as census-grade ratings.",
    bg: "#2563EB22", border: "#2563EB55", color: "#60A5FA",
  },
  PANEL: {
    title: "Panel-measured",
    body: "These numbers come from a USSD survey panel (sample size + region disclosed in /methodology). 95% confidence interval applies.",
    bg: "#D9770622", border: "#D9770655", color: "#FBBF24",
  },
  DIRECT: {
    title: "Direct stream measurement",
    body: "These numbers are direct Icecast/Shoutcast connection counts. The most reliable layer of the WaveScore stack.",
    bg: "#10B98122", border: "#10B98155", color: "#34D399",
  },
  HYBRID: {
    title: "Hybrid (panel + model)",
    body: "Blended from a USSD panel survey + live model. Best-of-both numbers for decision-making.",
    bg: "#A855F722", border: "#A855F755", color: "#C084FC",
  },
};

export function MethodologyBanner({ source = "MODEL", compact = false }) {
  const c = COPY[source] || COPY.MODEL;
  return (
    <div data-testid={`methodology-banner-${source.toLowerCase()}`}
      style={{
        background: c.bg, border: `1px solid ${c.border}`,
        borderRadius: 8, padding: compact ? "8px 12px" : "12px 16px",
        marginBottom: 12, display: "flex", gap: 12, alignItems: "flex-start",
        fontSize: compact ? 11 : 12, lineHeight: 1.5,
      }}>
      <div style={{
        background: c.color, color: "#0A1628", padding: "2px 8px", borderRadius: 4,
        fontSize: 10, fontWeight: 800, letterSpacing: "0.08em", flexShrink: 0, marginTop: 1,
      }}>
        {source}
      </div>
      <div style={{ color: c.color }}>
        <div style={{ fontWeight: 700, marginBottom: compact ? 0 : 2 }}>{c.title}</div>
        {!compact && (
          <div style={{ color: C.muted, fontWeight: 400 }}>
            {c.body}{" "}
            <Link to="/methodology" data-testid="methodology-link" style={{ color: c.color, textDecoration: "underline" }}>
              How we measure ↗
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
